var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "dialog-modal" }, [
        _c("div", { staticClass: "dialog-box" }, [
          _c("div", { staticClass: "dialog-head" }, [
            _c("p", [_vm._v(_vm._s(_vm.title))]),
            _vm._v(" "),
            _c("img", {
              staticClass: "close-icon",
              attrs: {
                src: "//img1.jianyewy.com/10dd567139556a4a3dea7b9c28559a80.png",
                alt: ""
              },
              on: {
                click: function($event) {
                  _vm.modalClick("cancel")
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "dialog-body" }, [
            _c("div", { staticClass: "reason" }, [
              _c("p", [
                _c("span", [_vm._v("*")]),
                _vm._v("\n          " + _vm._s(_vm.title) + "：\n        ")
              ]),
              _vm._v(" "),
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.inputContent,
                    expression: "inputContent"
                  }
                ],
                attrs: { placeholder: "请输入" },
                domProps: { value: _vm.inputContent },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.inputContent = $event.target.value
                  }
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "dialog-btn" }, [
              _c(
                "a",
                {
                  staticClass: "primary",
                  attrs: { href: "javascript:;" },
                  on: {
                    click: function($event) {
                      _vm.modalClick("submit")
                    }
                  }
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "default",
                  attrs: { href: "javascript:;" },
                  on: {
                    click: function($event) {
                      _vm.modalClick("cancel")
                    }
                  }
                },
                [_vm._v("取消")]
              )
            ])
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }